import React, { useCallback, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { AnimatedContainer, ButtonLoadingForm, FormContainer } from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import Input from '../../../components/Input';
import { useUser } from '../../../hooks/user';
import getValidationErrors from '../../../utils/getValidationErrors';

interface formProps {
  email: string;
}

export const Email: React.FC<ComponentUserRegisterProps> = ({ nextPage }) => {
  const formRef = useRef<FormHandles>(null);
  const [btnIsLoading, setBtnIsLoading] = useState<boolean>(false);

  const { setUser } = useUser();

  const handleNext = useCallback(async () => {
    const data = formRef?.current?.getData() as formProps;

    try {
      setBtnIsLoading(true);

      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        email: Yup.string()
          .required('O e-mail é obrigatório')
          .email('Digite um email válido'),
        confirmEmail: Yup.string()
          .oneOf([Yup.ref('email'), undefined], 'Os e-mails devem coincidir')
          .required('Confirmação de e-mail é obrigatória'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      setUser(prev => ({ ...prev, email: data.email }));

      nextPage();
    } catch (err) {
      setBtnIsLoading(false);

      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
      }
    }
  }, [setUser, nextPage]);

  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={1} titles={stepLabels} />

      <h1>Seu e-mail</h1>

      <FormContainer>
        <p>
          Informe e confirme nos campos abaixo seu e-mail para receber
          notificações e atualizações sobre o CINCO.
        </p>

        <Form ref={formRef} onSubmit={handleNext}>
          <Input
            name="email"
            label="Insira o seu email"
            isRequired
            type="email"
          />
          <Input
            name="confirmEmail"
            label="Confirme o seu email"
            isRequired
            type="email"
          />
        </Form>
      </FormContainer>

      <ButtonLoadingForm
        isLoading={btnIsLoading}
        btnType="darkBlue"
        onClick={handleNext}
      >
        Próximo
      </ButtonLoadingForm>
    </AnimatedContainer>
  );
};
